import { render, staticRenderFns } from "./PrivateStudents.vue?vue&type=template&id=f6b9d97a&scoped=true"
import script from "./PrivateStudents.vue?vue&type=script&lang=js"
export * from "./PrivateStudents.vue?vue&type=script&lang=js"
import style0 from "./PrivateStudents.vue?vue&type=style&index=0&id=f6b9d97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b9d97a",
  null
  
)

export default component.exports